import type { AppLinkId } from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';
import type { State } from '../../types.tsx';

export const getLinkedSpaces = (
	state: State,
): {
	name: string;
	key: string;
	appLinkId: AppLinkId;
}[] => state.entities.spaces?.linkedSpaces.data ?? [];
